import {WidgetEventStruct} from '../../widget-event.struct';
import {SubscriberWidgetEnum} from '../../../enums';

export class SubscriberWidgetEventStruct extends WidgetEventStruct {
  public event_runtime_widget_type: SubscriberWidgetEnum;
} // end Package
